var React = require('react');

function Filetable (props) {
    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"filetable"),React.createElement("path",{"d":"M17.981 7.086V22.21a1.73 1.73 0 0 1-1.726 1.729H1.724A1.73 1.73 0 0 1-.002 22.21V1.738A1.73 1.73 0 0 1 1.724.011h9.264c.046 0 .085.02.129.026a.769.769 0 0 1 .125.025c.172.046.331.12.453.241l5.885 5.873c.031.022.047.061.076.086.029.028.051.058.077.089.154.175.267.387.267.638 0 .035-.016.063-.019.097zm-5.994-3.672v2.578h2.583l-2.583-2.578zm3.996 4.572h-4.995a.998.998 0 0 1-.999-.997V1.97H2l-.003 19.975h13.986V7.986zM3.995 9.981h9.99c.552 0 .999.446.999.997v7.976c0 .55-.447.997-.999.997h-9.99a.998.998 0 0 1-.999-.997v-7.976c0-.551.446-.997.999-.997zm8.991 1.994H8.99v1.994h3.996v-1.994zm0 3.988H8.99v1.994h3.996v-1.994zm-7.992 1.994h1.998v-1.994H4.994v1.994zm0-3.988h1.998v-1.994H4.994v1.994z","key":1})]);
}

Filetable.displayName = "Filetable";

Filetable.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 18 23.94"};

module.exports = Filetable;

Filetable.default = Filetable;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/filetable.svg
// module id = 1268
// module chunks = 0